<template>
    <div class="t_content_view">
        <div class="t_search_box">
            <div class="t_search_select">
                <span style="color: #6D6D6D;">企微主体：</span>
                <el-select style="width: 180px;"  size="small" v-model="searchdata.corp_ids" collapse-tags multiple clearable placeholder="请选择">
                   
                    <el-option v-for="(item,index) in corpList.data" 
                    :key="index"
                    :label="item.corp_name" :value="item.id" />
                </el-select>
            </div>
            <div class="t_search_select">
                <span style="color: #6D6D6D;">资源账号：</span>
                <el-select style="width: 180px;"  size="small" v-model="searchdata.add_by" collapse-tags multiple clearable placeholder="请选择">
                   
                    <el-option v-for="(item,index) in allpeolist.data" 
                    :key="index"
                    :label="item.name" :value="item.id" />
                </el-select>
            </div>
            <div class="t_search_select">
                <span style="color: #6D6D6D;">来源渠道：</span>
                <el-select style="width: 180px;"  size="small" v-model="searchdata.source" clearable placeholder="请选择">
                   <el-option v-for="(item,index) in allqdlist.data" 
                    :key="index"
                    :label="item" 
                    :value="item" />
                </el-select>
            </div>
            <div class="t_search_select" >
                <el-date-picker
                    size="small" 
                    v-model="searchdate.data"
                    type="daterange"
                    @change="changedate"
                    value-format="YYYY-MM-DD"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    :default-time="defaultTime.data"
                />
            </div>
            <!-- <div class="t_search_select" style="padding-top:0 ;padding-bottom: 0;">
                <span style="color: #6D6D6D;">成员/部门：</span>
                <el-cascader
                    v-model="bmdata.data"
                    :options="Tree.treedata"
                    @change="handleChange"
                    collapse-tags
                    clearable
                    :props="{ value: 'departId', label: 'label', children: 'children',multiple: true}"
                    style="width: 250px;"
                />
            </div> -->
            <el-button @click="resbtn" color="#F1F3F9" style="margin-bottom: 10px;" type="primary">重置</el-button>
            <el-button @click="searchbtn" color="#F1F3F9" style="margin-bottom: 10px;" type="primary">搜索</el-button>
            
        </div>
      <el-button @click="daochu" color="#4F46E5" class="t_add_people"  type="primary"  >下载全部订单明细</el-button>
        
        
        <el-table :header-cell-style="{ background: '#F1F3F9' }" 
        :data="tableData.data" 
        style="width: 100%">
            <el-table-column prop="title" align="center" label="日期" />
            <el-table-column prop="customer_count" align="center" label="添加客户数" />
            <el-table-column prop="order_count" align="center" label="下单数" />
            <el-table-column prop="apply_amount" align="center" label="操作" >
                <template #default="scope">
                    <el-button type="text" @click="daochu(scope.row)">下载订单明细</el-button>
                </template>
            </el-table-column>
        </el-table>
        
        <!-- 分页 -->
        <!-- <pagechange :total="total" :nowpage="searchdata.page" @page_change="page_change" /> -->
    </div>

</template>
<script setup>
import { ref, reactive, provide, onBeforeMount, onMounted, watch,inject,beforeMount } from 'vue'
import { ElMessage,ElMessageBox } from 'element-plus'
//导入子组件
import pagechange from '../components/pagechange.vue'
import { khlist,qdtypelist,qdmlist,bqlist,tbkh,pladd,pldel ,khdetail,getfourdata,newgetdatatj,newgetdatatjall,newgetdatatjtop,newexportdata,newgetcomp2,newgetmanchange,newgetmanchangeexport,newgetpeo,newgetsource} from '@/assets/js/common.js'
//动态获取接口地址
const _url2 = inject('_url2')

onMounted(() => {
    console.log('onMounted')
    getDefaultTime()
    // //获取列表
    getlist()
    // //同步部门列表
    // nowgetbmtree()
    // //获取4个数据
    gettopnum()
    //获取企微主体下拉
    getcorplist()
    //获取所有成员下拉
    getallpeolist()
    //获取所有渠道下拉
    getallqdlist()
    
})
const getDefaultTime =  ()=> {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    //getCurrentTime方法见js方法中，中国标准时间转年月日时分秒
    searchdate.data[0]=getCurrentTime(start)
    searchdate.data[1]=getCurrentTime(end)
    searchdata.start_time =getCurrentTime(start) 
    searchdata.end_time = getCurrentTime(end)

}

//顶部数量
const topcont = reactive({
    data:{}
})
const gettopnum = ()=>{
    newgetdatatjtop().then((response)=>{
        if(response.data.msg.code==0){
           console.log('pp')
           console.log(response.data.data)
           topcont.data = response.data.data
        }
    })
}

//搜索
//企微主体下拉
const corpList = reactive({
    data:[]
})
//获取企微主体下拉
const getcorplist = ()=>{
    newgetcomp2().then((response)=>{
        if (response.data.msg.code == 0) {
            corpList.data = response.data.data
            console.log('企微主体下拉')
            console.log(corpList.data)
        }
    })
}

//所有成员下拉数组
const allpeolist = reactive({
    data:[]
})
//获取所有成员下拉
const getallpeolist = ()=>{
    newgetpeo({include_disabled:1}).then((response)=>{
        if (response.data.msg.code == 0) {
            allpeolist.data = response.data.data
        }
    })
}
//所有渠道下拉
const allqdlist = reactive({
    data:[]
})
//获取所有渠道下拉
const getallqdlist = ()=>{
    newgetsource().then((response)=>{
        if (response.data.msg.code == 0) {
            // console.log(response.data.result)
            allqdlist.data = response.data.data
        }
    })
}

//搜索
const searchdata = reactive({
   //当前页
        start_time:'',
        end_time:'',
        corp_ids:'',
        source:'',
        add_by:''
})
//重置
const resbtn = ()=>{
    searchdata.start_time = ''
    searchdata.end_time = ''
    searchdata.corp_ids = ''
    searchdata.source = ''
    searchdata.add_by = ''
    getDefaultTime()
    getlist()
}
//搜索
const searchbtn = ()=>{
    getlist()
}






//搜所日期
const searchdate = reactive({
    data:[]
})
//搜索日期变化
const changedate = (val)=>{
    console.log(val)
    // console.log(val[0])
    if(val){
        searchdata.start_time = val[0]
        searchdata.end_time = val[1]
    }else{
        searchdata.start_time = ''
        searchdata.end_time = ''
    }
    getlist()
}
//列表数据
const tableData = reactive({
    data:[]
})
//成员总数
const total = ref(0)
//获取客户管理列表
const getlist = ()=>{
    newgetmanchange(searchdata).then((response)=>{
        // console.log('----')
        // console.log(response.data.msg.code)
        if (response.data.msg.code == 0) {
            console.log('列表')
            console.log(response.data.data)

            tableData.data=response.data.data
        }
    })

}
//监听分页
// const page_change = (val)=>{
//     searchdata.page = val
//     //人员列表
//     getlist()
// }



//导出
const daochu = (row)=>{
if(row){
    searchdata.tab_time = row.title
}else{
    searchdata.tab_time = ''
}

newgetmanchangeexport(searchdata).then((response)=>{
        if(response.data.msg.code==0){
            console.log('---导出')
            console.log(response.data.data)
            window.open(window.location.origin+'/'+response.data.data.url,'_blank')
        }
        
    })


    return

    // exportallnum(_url2,).then((response)=>{
    //     if (response.data.msg.code == 0) {
            
    //         console.log(response)
            
    //     }
    // })
    ElMessage({
        message: '正在导出，请稍后...',
        type: 'success',
    })

    var obj = {
        department_ids:searchdata.department_ids,
        start_time:searchdata.start_time,
        end_time:searchdata.end_time,
        corpId:$cookies.get("fanscorpId")
    }
    
    var exportL = JSON.parse(JSON.stringify(obj));

    
    var str = '?'
    for (let key in exportL) {
        str=str+key+'='+exportL[key]+'&'
    }
    console.log( str.slice(0, -1))
    const a = document.createElement('a');
    a.setAttribute('download', '');
    a.setAttribute('href', _url2 + `/work/bcDepartmentUser/departmentUserExportXls`+ str.slice(0, -1));
    a.click();
}

const defaultTime = reactive({
    data:[
        new Date(2000, 1, 1, 0, 0, 0),
        new Date(2000, 2, 1, 23, 59, 59),
    ]
})
    //中国标准时间转化
    const getCurrentTime =  (date)=> {
    // let date = new Date()
    var year = date.getFullYear() //返回指定日期的年份
    var month = repair(date.getMonth() + 1);//月
    var day = repair(date.getDate());//日
    var hour = repair(date.getHours());//时
    var minute = repair(date.getMinutes());//分
    var second = repair(date.getSeconds());//秒
    
    //当前时间 
    var curTime = year + "-" + month + "-" + day;
    console.log(curTime)
    //返回 2022-11-25
    return curTime;
    }
    //补0
const repair = (i)=>{
    if (i >= 0 && i <= 9) {
        return "0" + i;
    } else {
        return i;
    }
}

</script>
<style scoped>


:deep( .t_search_box .el-input__wrapper ){
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}

.t_add_people {
    margin-top: 20px;
    margin-bottom: 20px;
}

.t_head_box {
    display: flex;
    align-items: center;
}

/* .t_content_view {
    padding: 20px;
} */
/* .t_cz_box{
    display: flex;
    justify-content: flex-end;
} */
.t_all_tag{
    margin-top: 10px;
    margin-right: 10px;
}
.t_tagchoose_box{
    margin-bottom:30px
}
.t_tj_box{
    width: 230px;
    height: 100px;
    border: 1px solid #CBD4E5;
    margin-right: 16px;
    background-color: #EDF3F8;
}
.t_tj_box_num{
    font-size: 29px;
    color: #144CFF;
    text-align: center;
    margin-top: 17px;
}
.t_tj_all{
    font-size: 15px;
    text-align: center;
}
.t_all_data{
    background-color: #E5EFF8;
    padding: 16px 0;
    font-size: 15px;
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
}
:deep(.el-cascader__tags){
    flex-wrap: nowrap;
}
:deep(.t_search_select .el-select__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
</style>